import { formSubmitGeneral, fileInput } from "../components/forms";

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

   /* eslint-disable */

    /* eslint-enable 

    // General Contact Form Message - Success
    function wpcf7_form_submit(formId) {

      // Form Succuess
      $(formId).on('wpcf7:mailsent', function(){
          $(formId + ' .form-content-wrap').animate({
            opacity: 0,
            duration: 450,
            easing: 'easeInOutQuad',
            height: 0,
          });

          $(formId + ' .form-response-wrap').addClass('active');
          $(formId + ' .form-response-wrap .success').addClass('active');
      });

    // Form Failed
      $(formId).on('wpcf7mailfailed', function(){
          $(formId + ' .form-content-wrap').animate({
            opacity: 0,
            duration: 450,
            easing: 'easeInOutQuad',
            height: 0,
          });

          $(formId + ' .form-response-wrap').addClass('active');
          $(formId + ' .form-response-wrap .failed').addClass('active');
      });
    }

    // WCF7 Failed Message - refresh page
    $('.failed .reload').on('click', function() {
        location.reload();
    });
    */

    
    // Contact Page
    // wpcf7_form_submit('#contact-section-three'); 

    formSubmitGeneral('contact-form', 'contact_page_form', 'contact page form')
    fileInput()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js